import { render, staticRenderFns } from "./PropertiesView.vue?vue&type=template&id=9801dcba&scoped=true&"
import script from "./PropertiesView.vue?vue&type=script&lang=js&"
export * from "./PropertiesView.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesView.vue?vue&type=style&index=0&id=9801dcba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9801dcba",
  null
  
)

export default component.exports